import { TrackingState } from '../../../models';
import { TRACKING_MUTATIONS_KEYS } from '../tracking.const';
import { TrackingMutation } from '../tracking.interfaces';

export class SetResultsEndMutation implements TrackingMutation {

  mutations = {
    [TRACKING_MUTATIONS_KEYS.setResultsEnd]: (localState: TrackingState, resultsEnd: boolean): void => {
      localState.resultsEnd = resultsEnd;
    }
  };
}
